module.exports = __webpack_public_path__ + "img/SWP_Axe_1H_03 (2).3db1133d.png";